export const getError = (error: any) => {
    try {
      if (!error || !error.response || !error.response.data) {
        return error;
      }
      const erro = {
        code: error.response.status,
        message: !!error.response.data.message
          ? error.response.data.message
          : error.response.statusText,
      };
      return erro;
      // eslint-disable-next-line no-shadow
    } catch (error) {
      const erro = {
        code: 500,
        message: "Erro interno comunique o administrador do sistema.",
      };
      return erro;
    }
  };


// WEBPACK FOOTER //
// ./src/services/ErrorService.tsx